<template>
  <core-main>
    <template v-slot:toolbar-title>
      {{ $t('form.engineeringTools.name') }}
    </template>

    <template #extension>
      <v-tabs
        v-model="selectedSettingsTab"
        horizontal
        class="fill-height"
      >
        <core-tab text="Material Properties" icon="mdi-file-cog-outline" />
        <core-tab text="Surface Finish Properties" icon="mdi-texture-box" />
        <core-tab text="Process Tolerances" icon="mdi-ruler-square" />
      </v-tabs>
    </template>

    <core-no-content />
  </core-main>
</template>

<script>
export default {
  name: 'EngineeringTools',

  data() {
    return {
      selectedSettingsTab: 0,
    };
  },
};
</script>

<style scoped>

</style>
